import {
    showGlobalShipModeDisplay
} from './_showGlobalShipModeDisplay';

export const showStorePickupTopDisplay = (display) => {
    if (display) {
		showGlobalShipModeDisplay(false);
        $('#addAddressButton').hide();
        $('#wrap-info').hide();
        $("#storePickUpStoreInfoSelection").show();
        
    }else{
       $('#wrap-info').show();
       $('#storePickUpStoreInfoSelection').hide();
       $('#storePickUpStoreInfo').hide();
       $("#storeShippingMessage").hide().html("");
       $("#optInText").hide();
       $('#storePickUpStates').val('');
       $('#storePickUpStores').empty().append('<optgroup hidden><option  selected="selected" disabled="disabled" >Select a City - Store</option></optgroup>');
     }
};


 